import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { MoodleService } from '../../../services/moodle.service';

@Component({
  selector: 'app-course-edit-dialog',
  templateUrl: './course-edit-dialog.component.html',
  styleUrl: './course-edit-dialog.component.scss',
})
export class CourseEditDialogComponent implements OnInit {
  @Input() courseId!: string;
  @Input() courseName!: string;

  loading = true;
  saving = false;

  description = '';
  metadataContext = '';
  learningGoals = '';
  difficultyLevel = '';
  syncFrequency = 'NEVER';
  participantSyncFrequency = 'NEVER';
  selectedDependencies: string[] = [];

  allCourses: Array<{ id: string; course_name: string }> = [];

  constructor(
    protected dialogRef: NbDialogRef<CourseEditDialogComponent>,
    protected moodleService: MoodleService,
    protected toastr: NbToastrService,
    protected translate: TranslateService
  ) {}

  ngOnInit() {
    this.moodleService.getCourseDetail(this.courseId).subscribe({
      next: (data: any) => {
        this.description = data.description || '';
        this.metadataContext = data.metadata_context || '';
        this.learningGoals = data.learning_goals || '';
        this.difficultyLevel = data.difficulty_level || '';
        this.syncFrequency = data.sync_frequency || 'NEVER';
        this.participantSyncFrequency = data.participant_sync_frequency || 'NEVER';
        this.selectedDependencies = (data.dependencies || []).map((d: any) => d.id);
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });

    this.moodleService.getClientCourses().subscribe({
      next: (courses: any[]) => {
        this.allCourses = courses.filter((c: any) => c.id !== this.courseId);
      },
    });
  }

  save() {
    this.saving = true;
    this.moodleService
      .updateCourse(this.courseId, {
        description: this.description,
        metadata_context: this.metadataContext,
        learning_goals: this.learningGoals,
        difficulty_level: this.difficultyLevel || undefined,
        sync_frequency: this.syncFrequency,
        participant_sync_frequency: this.participantSyncFrequency,
        dependency_ids: this.selectedDependencies,
      })
      .subscribe({
        next: () => {
          this.saving = false;
          this.toastr.success(
            this.translate.instant('dialogs.courseEdit.saveSuccess'),
            this.translate.instant('toasts.success')
          );
          this.dialogRef.close(true);
        },
        error: () => {
          this.saving = false;
          this.toastr.danger(
            this.translate.instant('dialogs.courseEdit.saveError'),
            this.translate.instant('toasts.error')
          );
        },
      });
  }

  close() {
    this.dialogRef.close();
  }
}
